module.exports = __webpack_public_path__ + "img/ChunjieXu.5aac1742.png";